import { ReactionsField as Reactions } from '@atlassian/jira-polaris-common/src/ui/fields/reactions/index.tsx';

export const ReactionsField = Reactions;
